import { LegacySdkRefPage } from '@squareup/dex-feature-dex-tech-docs-legacy-sdk-ref';

const Page = () => {
  return <LegacySdkRefPage platform="point_of_sale_ios" />;
};

export default Page;
